import InternalBar from './InternalBar';

export default InternalBar;
